import { PlaidTransaction } from '../types/transactions';

const NEEDS_REVIEW_STATUSES = new Set([
  'PENDING',
  'PROCESSING',
  'FAILED',
  'NO_MERCHANT_MATCH',
  'SKIPPED',
  'SYNC_LEGACY',
]);

export function getVendorDisplayLabel(t: Partial<PlaidTransaction>): string {
  const normalized = (t.normalizedMerchant || '').trim();
  if (normalized) return normalized;

  const status = (t.normalizationStatus || '').toUpperCase();
  if (status === 'NON_MERCHANT') return 'Non-Merchant';
  if (NEEDS_REVIEW_STATUSES.has(status)) return 'Needs Review';

  const merchantFallback = (t.merchantName || t.name || '').trim();
  if (merchantFallback) return merchantFallback;

  return 'Unknown';
}
